import { assert_instanceof, assert_is_safe_number, assert_not_null } from '@shared/asserts/utils_asserts';
import { FIELD__base } from '../../../_fields/_base/FIELD__base';
import { FIELD__list_base_generic } from '../../../_fields/_primitives/list/FIELD__list_base_generic';

export function FN_FIELD__get_by_name(parent_object: any, field_name: string): FIELD__base {
  let out: FIELD__base;

  if (field_name.includes(':')) {
    let [list_name, item_index_string] = field_name.split_by_first_entry(':');
    parent_object = parent_object[list_name];

    assert_not_null(parent_object);
    assert_instanceof(parent_object, FIELD__list_base_generic);

    let item_index = parseInt(item_index_string);
    assert_is_safe_number(item_index);

    out = parent_object.items[item_index];
  } else {
    out = parent_object[field_name];
  }

  assert_not_null(out);
  assert_instanceof(out, FIELD__base);

  return out;
}
